var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconBadgeHints = function SvgIconBadgeHints(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 40 40"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "icon_badge_hints_svg__a",
    width: "133.3%",
    height: "133.3%",
    x: "-16.7%",
    y: "-16.7%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowOffsetOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#5FA378",
    rx: 6
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    filter: "url(#icon_badge_hints_svg__a)",
    transform: "translate(8 8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.123 20v-2H9.565v2zm1.32-6.639c-.48.832-.72 1.723-.96 2.639h-1.44v-3.265l1.08-2.301c.24-.494.12-1.097-.36-1.338-.48-.24-1.08-.024-1.32.47l-.479.988-.84-1.132c-.24-.458-.84-.555-1.32-.23-.479.326-.479.94-.239 1.398l1.56 2.23V16h-1.8c-.12-.855-.48-1.687-.84-2.47l-.96-2.024C5.847 8.072 8.246 4 11.965 4c3.839 0 6.358 4.29 4.438 7.735zM11.964 2C6.806 2 3.447 7.639 5.727 12.41l1.08 2.012c.599 1.205.839 2.53.839 3.867v1.783c0 1.073.84 1.928 1.919 1.928h4.798c.96 0 1.68-.807 1.68-1.795v-1.771c0-1.434.48-2.844 1.079-4.085l.96-1.626C20.72 7.94 17.362 2 11.964 2"
  })))));
};
export default SvgIconBadgeHints;